import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpRequest } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { finalize, catchError } from "rxjs/operators";
import { LoaderService } from '../../loader/loader.service';
import { FILE_SCAN_URLS } from "src/app/shared/constants/antivirus-scan-constant";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})

export class LoaderInterceptorService {
  activeCalls: number = 0;
  isScanningApi: boolean = false;

  constructor(private readonly loaderService: LoaderService) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loaderService.setisLoading(true);
    if (req.headers.get('skip') == 'true') {
      this.loaderService.setisLoading(false);
    }

    if (
      req.url.includes(FILE_SCAN_URLS.pollingUrl) ||
      (req.url.includes(environment.FILE_SCAN_CONTAINER) &&
      req.method !== "DELETE") ||
      req.url.includes(FILE_SCAN_URLS.sasTokenUrl)
    ) {
      this.isScanningApi = true;
    } else {
      this.isScanningApi = false;
    }
    ++this.activeCalls;
    return next.handle(req).pipe(
      catchError((err) => {
        return throwError(err);
      }),
      finalize(() => {
        --this.activeCalls;
        if (!this.activeCalls && !this.isScanningApi)
          this.loaderService.setisLoading(false);
      })
    );
  }
}
